import { Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthenticationService } from "./authentication/authentication.service";
import { GlobalService } from "./global.service";
import { MatDialog, MatDialogConfig } from "@angular/material";
import { TimeMismatchAlertComponent } from "./time-mismatch-alert/time-mismatch-alert.component";

@Injectable({
  providedIn: "root",
})
export class HttpService {
  getWalletData() {
    throw new Error("Method not implemented.");
  }
  headers: HttpHeaders;
  get: any;

  constructor(
    private router: Router,
    private global: GlobalService,
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private dialog: MatDialog
  ) {
    console.log("http constructor");
    this.headers = new HttpHeaders();
    this.appendTokenToHeaderByLocalStorage();
    this.authenticationService.login_event.subscribe((data) => {
      this.setTokentoHeaders(data);
    });
  }

  setTokentoHeaders(token: any) {
    localStorage.removeItem("auth-token");
    localStorage.setItem("auth-token", JSON.stringify(token));
    this.appendTokenToHeaderByLocalStorage();
  }

  // append token header from the local storage
  appendTokenToHeaderByLocalStorage() {
    let token = JSON.parse(localStorage.getItem("auth-token"));
    // let user_type = JSON.parse(localStorage.getItem('user_type'))
    if (token != null) {
      // console.log('Authorization');
      this.headers = new HttpHeaders({ Authorization: "Token " + token });
    }
  }

  async login(user_form) {
    this.http
      .post(`${this.global.server_url}/main/portal/login/for/token/`, user_form)
      .subscribe(
        (data) => {
          console.log(data);
          let server_date_time: any = new Date(data["server_time"]);
          let system_date_time: any = new Date();
          let difference_time_in_abs = Math.abs(
            server_date_time - system_date_time
          );
          let dirrent_time_in_minutes = Math.floor(
            difference_time_in_abs / 1000 / 60
          );
          console.log(dirrent_time_in_minutes);
          if (dirrent_time_in_minutes > 10) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.panelClass = "time-mismatch";
            this.dialog.open(TimeMismatchAlertComponent, dialogConfig);
          } else {
            localStorage.setItem("TOKEN_KEY", JSON.stringify(data["token"]));
            localStorage.setItem(
              "employee_id",
              JSON.stringify(data["employee_id"])
            );
            localStorage.setItem("first_name", data["first_name"]);
            localStorage.setItem("user_type", data["user_type_name"]);
            localStorage.setItem("user_image", data["user_image"]);
            localStorage.setItem("user_position", data["user_position_name"]);
            this.global.set_active_user = data["first_name"];
            this.global.set_active_image = data["user_image"];
            this.global.set_active_user_type = data["user_type_name"];
            // this.global.set_active_user_type_name = data['user_type_name']

            this.global.set_active_user_position = data["user_position_name"];
            // localStorage.setItem('user_profile', JSON.stringify(data['user_profile']));
            // localStorage.setItem('user_type', JSON.stringify(data['user_profile']['user_type']));
            this.authenticationService.authendicationState.next(true);
            this.authenticationService.login_event.emit(data["token"]);
            this.getEmployeeRoleMenu();
            // this.http.setTokentoHeaders(data['token']);
            // this.router.navigateByUrl('/');
            this.router.navigateByUrl("dashboard");
          }
        },
        (error) => {
          console.log(error);
          const error_message = error["detail"];
          alert(error_message);
        }
      );
  }

  async getCurrentDate() {
    return this.http
      .get(`${this.global.server_url}/main/serve/current/date/`)
      .toPromise()
      .then((current_date) => {
        console.log(current_date);
        return current_date;
      })
      .catch((error) => {
        console.error(error);
      });
  }

  getUserTypes() {
    return this.http.get(`${this.global.server_url}/main/serve/user/types/`, {
      headers: this.headers,
    });
  }

  registerZone(data) {
    return this.http.post(`${this.global.server_url}/main/save/zone/`, data, {
      headers: this.headers,
    });
  }

  registerBoothType(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/booth/type/`,
      data,
      { headers: this.headers }
    );
  }

  getDistrict() {
    return this.http.get(`${this.global.server_url}/main/serve/district/`, {
      headers: this.headers,
    });
  }

  registerConstituency(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/constituency/`,
      data,
      { headers: this.headers }
    );
  }

  registerWard(data) {
    return this.http.post(`${this.global.server_url}/main/save/ward/`, data, {
      headers: this.headers,
    });
  }

  getConstituency() {
    return this.http.get(`${this.global.server_url}/main/serve/constituency/`, {
      headers: this.headers,
    });
  }

  getZones() {
    console.log("came inside http");
    return this.http.get(`${this.global.server_url}/main/serve/zones/`, {
      headers: this.headers,
    });
  }

  getMorRoutes() {
    console.log("came inside http");
    return this.http.get(`${this.global.server_url}/main/serve/mor/route/`, {
      headers: this.headers,
    });
  }

  getBoothTypes() {
    return this.http.get(`${this.global.server_url}/main/serve/booth/types/`, {
      headers: this.headers,
    });
  }

  getWards() {
    return this.http.get(`${this.global.server_url}/main/serve/wards/`, {
      headers: this.headers,
    });
  }

  getAgents() {
    return this.http.get(`${this.global.server_url}/main/serve/agents/`, {
      headers: this.headers,
    });
  }

  getProductGroup() {
    return this.http.get(
      `${this.global.server_url}/main/serve/product/group/`,
      { headers: this.headers }
    );
  }

  getUnions() {
    return this.http.get(`${this.global.server_url}/main/serve/unions/`, {
      headers: this.headers,
    });
  }

  getLocationCategories() {
    return this.http.get(
      `${this.global.server_url}/main/serve/location/categories/`,
      { headers: this.headers }
    );
  }

  saveProductGroup(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/product/group/`,
      data,
      { headers: this.headers }
    );
  }

  saveProduct(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/product/`,
      data,
      { headers: this.headers }
    );
  }

  getProduct() {
    return this.http.get(`${this.global.server_url}/main/serve/product/`, {
      headers: this.headers,
    });
  }

  getMilkProduct() {
    return this.http.get(`${this.global.server_url}/main/serve/milk/product/`, {
      headers: this.headers,
    });
  }

  getProductUnit() {
    return this.http.get(`${this.global.server_url}/main/serve/product/unit/`, {
      headers: this.headers,
    });
  }

  getBooths() {
    return this.http.get(`${this.global.server_url}/main/serve/booths/`, {
      headers: this.headers,
    });
  }

  getGenders() {
    return this.http.get(`${this.global.server_url}/main/serve/genders/`, {
      headers: this.headers,
    });
  }

  getTaluks() {
    return this.http.get(`${this.global.server_url}/main/serve/taluks/`, {
      headers: this.headers,
    });
  }

  getStates() {
    return this.http.get(`${this.global.server_url}/main/serve/states/`, {
      headers: this.headers,
    });
  }

  getVehicleTransports() {
    return this.http.get(
      `${this.global.server_url}/main/serve/vehicle/transports/`,
      { headers: this.headers }
    );
  }

  getRelationTypes() {
    return this.http.get(
      `${this.global.server_url}/main/serve/relation/types/`,
      { headers: this.headers }
    );
  }

  registerProductUnit(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/product/unit/`,
      data,
      { headers: this.headers }
    );
  }

  registerBooth(data) {
    return this.http.post(`${this.global.server_url}/main/save/booth/`, data, {
      headers: this.headers,
    });
  }

  registerAgent(data) {
    return this.http.post(`${this.global.server_url}/main/save/agent/`, data, {
      headers: this.headers,
    });
  }

  registerVehicleTransport(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/vehicle/register/`,
      data,
      { headers: this.headers }
    );
  }

  registerVehicleType(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/vehicle/type/`,
      data,
      { headers: this.headers }
    );
  }

  registerRelationType(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/relation/type/`,
      data,
      { headers: this.headers }
    );
  }

  getCommissionBusinessDisplayColumns() {
    return this.http.get(
      `${this.global.server_url}/main/serve/commission/business/display/columns/`,
      { headers: this.headers }
    );
  }

  getNomineeAndBankInfoForAgentUpdate(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/nominee/bank/info/for/agent/update/`,
      data,
      { headers: this.headers }
    );
  }

  registerTaluk(data) {
    return this.http.post(`${this.global.server_url}/main/save/taluk/`, data, {
      headers: this.headers,
    });
  }
  getEmployee() {
    return this.http.get(`${this.global.server_url}/main/serve/employee/`, {
      headers: this.headers,
    });
  }

  getRole() {
    return this.http.get(
      `${this.global.server_url}/main/serve/employee/role/`,
      { headers: this.headers }
    );
  }

  getOffice() {
    return this.http.get(`${this.global.server_url}/main/serve/office/`, {
      headers: this.headers,
    });
  }

  registerEmployee(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/employee/`,
      data,
      { headers: this.headers }
    );
  }
  getEmployeeDetails(data) {
    return this.http.post(
      `${this.global.server_url}/main/get/employee/details/`,
      data,
      { headers: this.headers }
    );
  }

  registerUnionOffice(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/union/office/`,
      data,
      { headers: this.headers }
    );
  }

  registerLocationCategory(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/location/category/`,
      data,
      { headers: this.headers }
    );
  }

  getIcustomerList() {
    return this.http.get(
      `${this.global.server_url}/main/serve/icustomers/list/`,
      { headers: this.headers }
    );
  }

  getCustomerType() {
    return this.http.get(
      `${this.global.server_url}/main/serve/customer/type/`,
      { headers: this.headers }
    );
  }
  getcustomerunion() {
    return this.http.get(
      `${this.global.server_url}/main/serve/union/icustomers/`,
      { headers: this.headers }
    );
  }

  getExEmployeeUnion() {
    return this.http.get(
      `${this.global.server_url}/main/serve/ex/employee/union/`,
      { headers: this.headers }
    );
  }

  registerIcustomer(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/icustomer/`,
      data,
      { headers: this.headers }
    );
  }

  getIcustomerDetails(data) {
    return this.http.post(
      `${this.global.server_url}/main/get/icustomer/details/for/update/`,
      data,
      { headers: this.headers }
    );
  }

  getVehicletype() {
    return this.http.get(`${this.global.server_url}/main/serve/vehicle/type/`, {
      headers: this.headers,
    });
  }

  getVehicle() {
    return this.http.get(`${this.global.server_url}/main/serve/vehicle/`, {
      headers: this.headers,
    });
  }

  registerVehicle(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/vehicle/`,
      data,
      { headers: this.headers }
    );
  }

  getVehicleDetails(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/vehicle/details/for/update/`,
      data,
      { headers: this.headers }
    );
  }

  getRoute() {
    return this.http.get(`${this.global.server_url}/main/serve/route/`, {
      headers: this.headers,
    });
  }

  getSessions() {
    return this.http.get(`${this.global.server_url}/main/serve/session/`, {
      headers: this.headers,
    });
  }

  registerRoute(data) {
    return this.http.post(`${this.global.server_url}/main/save/route/`, data, {
      headers: this.headers,
    });
  }

  getBusinessTypeForCommissions() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/type/for/commission/`,
      { headers: this.headers }
    );
  }

  saveOrUpdateBusinssTypeWiseProductCommission(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/or/update/business/type/wise/product/commission/`,
      data,
      { headers: this.headers }
    );
  }

  getBusinessTypeWiseProductCommission() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/type/wise/product/commission/`,
      { headers: this.headers }
    );
  }

  getBusinessTypeCommissionProducts() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/type/commission/products/`,
      { headers: this.headers }
    );
  }

  getProductsNameDictType() {
    return this.http.get(
      `${this.global.server_url}/main/serve/products/name/dict/type/`,
      { headers: this.headers }
    );
  }

  getBusinessTypeNameDictType() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/type/name/dict/type/`,
      { headers: this.headers }
    );
  }

  getDiscountProducts() {
    return this.http.get(
      `${this.global.server_url}/main/serve/discount/products/`,
      { headers: this.headers }
    );
  }

  getDiscountBusiness() {
    return this.http.get(
      `${this.global.server_url}/main/serve/discount/business/`,
      { headers: this.headers }
    );
  }

  getBusinessWiseDiscountPriceDict() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/wise/discount/price/dict/`,
      { headers: this.headers }
    );
  }

  getIcustomerWiseDiscountPriceDict() {
    return this.http.get(
      `${this.global.server_url}/main/serve/icustomer/wise/discount/product/`,
      { headers: this.headers }
    );
  }

  saveOrUpdateBusinessWiseProductDiscountPrice(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/or/update/business/wise/product/discount/price/`,
      data,
      { headers: this.headers }
    );
  }

  getBusinessTypeWiseDiscountProduct() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/type/wise/discount/product/`,
      { headers: this.headers }
    );
  }

  getBusinessTypeWiseDiscountBusiness() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/type/wise/discount/business/types/`,
      { headers: this.headers }
    );
  }

  getBusinessTypeWiseDiscountPriceDict() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/type/wise/discount/price/dict/`,
      { headers: this.headers }
    );
  }

  saveOrUpdateBusinessTypeWiseProductDiscountPrice(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/or/update/business/type/wise/product/discount/price/`,
      data,
      { headers: this.headers }
    );
  }

  removeBusinessTypeWiseProductDiscountPrice(data) {
    return this.http.post(
      `${this.global.server_url}/main/remove/business/type/wise/product/`,
      data,
      { headers: this.headers }
    );
  }

  removeBusinessWiseProductDiscountPrice(data) {
    return this.http.post(
      `${this.global.server_url}/main/remove/business/wise/product/`,
      data,
      { headers: this.headers }
    );
  }

  getAllbusiness() {
    return this.http.get(`${this.global.server_url}/main/serve/all/business/`, {
      headers: this.headers,
    });
  }

  getAllbusinessForBothChange() {
    return this.http.get(
      `${this.global.server_url}/main/serve/all/business/for/booth/change/`,
      { headers: this.headers }
    );
  }

  getRoutes() {
    return this.http.get(`${this.global.server_url}/main/serve/routes/`, {
      headers: this.headers,
    });
  }

  routeBusinessMap(data) {
    return this.http.post(
      `${this.global.server_url}/main/route/business/map/`,
      data,
      { headers: this.headers }
    );
  }

  getBusinessByRoute(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/business/by/route/`,
      data,
      { headers: this.headers }
    );
  }

  removeBusinessFromRoute(data) {
    return this.http.post(
      `${this.global.server_url}/main/remove/business/from/route/`,
      data,
      { headers: this.headers }
    );
  }

  getProductForAgentOrder() {
    return this.http.get(
      `${this.global.server_url}/main/serve/products/for/agent/order/`,
      { headers: this.headers }
    );
  }

  getSession() {
    return this.http.get(`${this.global.server_url}/main/serve/session/`, {
      headers: this.headers,
    });
  }

  getIcustomerTypeWiseDiscountPrice() {
    return this.http.get(
      `${this.global.server_url}/main/serve/icustomer/type/wise/discount/price/dict/`,
      { headers: this.headers }
    );
  }

  saveOrUpdateIcustomerTypeWiseDiscount(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/or/update/icustomer/type/wise/discount/`,
      data,
      { headers: this.headers }
    );
  }

  getProductTraceLog() {
    return this.http.get(
      `${this.global.server_url}/main/serve/product/trace/log/`,
      { headers: this.headers }
    );
  }

  getBusinessTypeWiseProductCommissionTraceLog() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/type/wise/product/commission/trace/log/`,
      { headers: this.headers }
    );
  }

  getBusinessTypeWiseProductDiscountTraceLog() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/type/wise/product/discount/trace/log/`,
      { headers: this.headers }
    );
  }

  getBusinessWiseProductDiscountTraceLog() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/wise/product/discount/trace/log/`,
      { headers: this.headers }
    );
  }

  getIcustomerTypeWiseProductDiscountTraceLog() {
    return this.http.get(
      `${this.global.server_url}/main/serve/icustomer/wise/product/discount/trace/log/`,
      { headers: this.headers }
    );
  }

  getProductwithMrp() {
    return this.http.get(
      `${this.global.server_url}/main/serve/products/with/mrp/`,
      { headers: this.headers }
    );
  }

  generateBoothCode(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/booth/exists/`,
      data,
      { headers: this.headers }
    );
  }

  checkForBoothNameAvailbility(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/booth/name/availability/`,
      data,
      { headers: this.headers }
    );
  }

  checkForBoothCode(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/booth/code/`,
      data,
      { headers: this.headers }
    );
  }

  generateAgentCode() {
    return this.http.get(
      `${this.global.server_url}/main/generate/agent/code/`,
      { headers: this.headers }
    );
  }

  getBusinessLastSale(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/serve/business/last/sale/`,
      data,
      { headers: this.headers }
    );
  }

  getBusinessTypeWiseProductPrice(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/serve/business/type/wise/product/price/`,
      data,
      { headers: this.headers }
    );
  }

  placeAgentOrder(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/place/agent/order/`,
      data,
      { headers: this.headers }
    );
  }

  getBusinessOrderExpiryTime(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/serve/order/expiry/time/by/business/`,
      data,
      { headers: this.headers }
    );
  }

  getUnmapedBusinessWithRoute(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/serve/unmapped/business/with/route/session/`,
      data,
      { headers: this.headers }
    );
  }

  getBusinessOrderFutureDate(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/serve/business/order/future/date/`,
      data,
      { headers: this.headers }
    );
  }

  getOverallIndentData(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/serve/indent/overall/data/`,
      data,
      { headers: this.headers }
    );
  }

  getOverallIndentDataForOldIndent(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/serve/indent/overall/data/for/old/indent/`,
      data,
      { headers: this.headers }
    );
  }

  getIndentRouteWiseData(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/serve/all/route/wise/data/`,
      data,
      { headers: this.headers }
    );
  }

  getIndentRouteWiseDataForOldindent(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/serve/all/route/wise/data/for/old/indent/`,
      data,
      { headers: this.headers }
    );
  }

  prepareRouteIndent(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/prepare/route/indent/`,
      data,
      { headers: this.headers }
    );
  }

  prepareRouteIndentForTempRoute(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/close/temp/and/main/route/`,
      data,
      { headers: this.headers }
    );
  }

  getPreparedIndentRouteIds(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/serve/prepared/indent/route/ids/`,
      data,
      { headers: this.headers }
    );
  }

  getRouteIndentDetails(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/serve/route/indent/details/`,
      data,
      { headers: this.headers }
    );
  }

  checkVehicleAssignedToAnotherRoute(data) {
    console.log(data);
    return this.http.post(
      `${this.global.server_url}/main/check/vehicle/assigned/to/another/route/`,
      data,
      { headers: this.headers }
    );
  }

  getProductAvailabilityForPortal() {
    return this.http.get(
      `${this.global.server_url}/main/serve/product/availability/for/portal/ `,
      { headers: this.headers }
    );
  }

  changeProductAvailability(data) {
    return this.http.post(
      `${this.global.server_url}/main/change/product/availability/ `,
      data,
      { headers: this.headers }
    );
  }

  // agent order api
  getLastDateForAgentOrder(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/last/date/for/agent/order/`,
      data,
      { headers: this.headers }
    );
  }

  getProductList(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/product/list/`,
      data,
      { headers: this.headers }
    );
  }

  serveSingleSalegroup(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/sale/for/selected/date/`,
      data,
      { headers: this.headers }
    );
  }

  checkOrderExists(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/order/exists/`,
      data,
      { headers: this.headers }
    );
  }

  serveCustomerBusinessDetails(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/customer/business/details/`,
      data,
      { headers: this.headers }
    );
  }

  serveProductListForICustomer(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/product/list/for/icustomer/`,
      data,
      { headers: this.headers }
    );
  }

  serveLastMonthOrderForICustomer(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/last/month/order/for/icustomer/`,
      data,
      { headers: this.headers }
    );
  }

  registerOrderForICustomer(data) {
    return this.http.post(
      `${this.global.server_url}/main/register/order/for/icustomer/`,
      data,
      { headers: this.headers }
    );
  }

  checkIcustomerDetails(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/icustomer/details/`,
      data,
      { headers: this.headers }
    );
  }

  registerOrderForAgent(data) {
    return this.http.post(
      `${this.global.server_url}/main/register/order/for/agent/`,
      data,
      { headers: this.headers }
    );
  }

  serveIcustomerHistory(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/icustomer/latest/twelve/orders/`,
      data,
      { headers: this.headers }
    );
  }

  serveSelectedMonthSaleForIcustomer(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/icustomer/selected/month/sale/group/`,
      data,
      { headers: this.headers }
    );
  }

  serveBoothOrderHistoryForPast(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/sale/details/for/last/week/`,
      data,
      { headers: this.headers }
    );
  }

  serveBoothOrderHistoryForFuture(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/sale/details/for/future/week/`,
      data,
      { headers: this.headers }
    );
  }

  getRouteIndentStatusPerSession(data) {
    return this.http.post(
      `${this.global.server_url}/main/get/route/indent/status/per/session/`,
      data,
      { headers: this.headers }
    );
  }

  getBusinessBill(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/business/bill/`,
      data,
      { headers: this.headers }
    );
  }

  getTrayConfig() {
    return this.http.get(`${this.global.server_url}/main/serve/tray/config/`, {
      headers: this.headers,
    });
  }

  serveBoothChangeTimeRange() {
    return this.http.get(
      `${this.global.server_url}/main/serve/booth/change/time/range/`,
      { headers: this.headers }
    );
  }

  serveFromTimeForBoothChange() {
    return this.http.get(
      `${this.global.server_url}/main/serve/from/time/for/booth/change/`,
      { headers: this.headers }
    );
  }

  getRouteGatePass(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/route/gate/pass/`,
      data,
      { headers: this.headers }
    );
  }

  getRouteSessionWise() {
    return this.http.get(
      `${this.global.server_url}/main/serve/route/session/wise/`,
      { headers: this.headers }
    );
  }

  getRouteVehicleMap() {
    return this.http.get(
      `${this.global.server_url}/main/serve/route/vehicle/map/`,
      { headers: this.headers }
    );
  }

  getRouteVehiclelog() {
    return this.http.get(
      `${this.global.server_url}/main/serve/route/vehicle/map/log/`,
      { headers: this.headers }
    );
  }

  changeBusinessArrayOrder(data) {
    return this.http.post(
      `${this.global.server_url}/main/change/business/ordinal/in/route/map/`,
      data,
      { headers: this.headers }
    );
  }

  getIntentForBusinessWise(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/intent/for/business/wise/`,
      data,
      { headers: this.headers }
    );
  }
  serveAgentMonthlyReport(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/agent/monthly/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveRouteWiseBusinessSaleReports(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/route/wise/business/sale/reports/`,
      data,
      { headers: this.headers }
    );
  }

  closeOverallIntent(data) {
    return this.http.post(
      `${this.global.server_url}/main/close/overall/intent/`,
      data,
      { headers: this.headers }
    );
  }

  PrepareCanvas(data) {
    return this.http.post(
      `${this.global.server_url}/main/create/canvas/report/`,
      data,
      { headers: this.headers }
    );
  }

  getCorporationZone() {
    return this.http.get(
      `${this.global.server_url}/main/serve/corporation/zone/`,
      { headers: this.headers }
    );
  }

  registerCorporationZone(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/corporation/zone/`,
      data,
      { headers: this.headers }
    );
  }

  getAgentImage(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/agent/image/`,
      data,
      { headers: this.headers }
    );
  }

  saveDistrict(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/district/`,
      data,
      { headers: this.headers }
    );
  }

  getBlocks() {
    return this.http.get(`${this.global.server_url}/main/serve/block/`, {
      headers: this.headers,
    });
  }

  serveUnActiveCounter() {
    return this.http.get(
      `${this.global.server_url}/main/serve/un/active/counter/`,
      { headers: this.headers }
    );
  }

  serveCounteOrders() {
    return this.http.get(
      `${this.global.server_url}/main/serve/counter/orders/`,
      { headers: this.headers }
    );
  }

  serveIcustomerCounteOrders() {
    return this.http.get(
      `${this.global.server_url}/main/serve/icustomer/counter/orders/`,
      { headers: this.headers }
    );
  }

  saveBlock(data) {
    return this.http.post(`${this.global.server_url}/main/save/block/`, data, {
      headers: this.headers,
    });
  }

  getIndentPdf(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/indent/pdf/`,
      data,
      { headers: this.headers }
    );
  }

  getIndentPdfForOldIndent(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/indent/pdf/for/old/indent/`,
      data,
      { headers: this.headers }
    );
  }

  checkForOverallRouteClose(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/overall/route/closed/`,
      data,
      { headers: this.headers }
    );
  }

  rePrepareIndent(data) {
    return this.http.post(
      `${this.global.server_url}/main/reprepare/indent/`,
      data,
      { headers: this.headers }
    );
  }

  checkForOverallRouteCloseForOldIndent(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/overall/route/closed/for/old/indent/`,
      data,
      { headers: this.headers }
    );
  }

  checkForBoothAndAgentExists(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/booth/agent/exists/`,
      data,
      { headers: this.headers }
    );
  }

  getPaymentModes() {
    return this.http.get(`${this.global.server_url}/main/get/payment/modes/`, {
      headers: this.headers,
    });
  }

  AddMoneyToWallet(data) {
    return this.http.post(
      `${this.global.server_url}/main/add/money/to/wallet/`,
      data,
      { headers: this.headers }
    );
  }

  getChequeStatusLog() {
    return this.http.get(
      `${this.global.server_url}/main/get/cheque/status/logs/`,
      { headers: this.headers }
    );
  }

  saveApproval(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/cheque/approal/`,
      data,
      { headers: this.headers }
    );
  }

  serveTransactionLogAndWalletBalance(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/last/week/transaction/log/and/wallet/balance/`,
      data,
      { headers: this.headers }
    );
  }

  getbusinesstype() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/type/`,
      { headers: this.headers }
    );
  }

  receivedDepositAmount(data) {
    return this.http.post(
      `${this.global.server_url}/main/business/group/credit/limit/ `,
      data,
      { headers: this.headers }
    );
  }

  businessgrouppaymentreceived(data) {
    return this.http.post(
      `${this.global.server_url}/main/business/group/payment/received/ `,
      data,
      { headers: this.headers }
    );
  }

  serveCounterStop(data) {
    return this.http.post(
      `${this.global.server_url}/main/counter/stop/configuration/`,
      data,
      { headers: this.headers }
    );
  }

  assignCounterToEmployee(data) {
    return this.http.post(
      `${this.global.server_url}/main/assign/counter/to/employee/`,
      data,
      { headers: this.headers }
    );
  }

  updateSelectedSaleGroup(data) {
    return this.http.post(
      `${this.global.server_url}/main/update/selected/sale/group/`,
      data,
      { headers: this.headers }
    );
  }

  serveBoothListUnderPincode(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/booth/under/pincode/`,
      data,
      { headers: this.headers }
    );
  }

  linkBoothWithCustomer(data) {
    return this.http.post(
      `${this.global.server_url}/main/link/booth/with/customer/`,
      data,
      { headers: this.headers }
    );
  }

  serveSelecetedBoothDetails(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/selected/booth/details/`,
      data,
      { headers: this.headers }
    );
  }

  serveBoothLatLng() {
    return this.http.get(
      `${this.global.server_url}/main/serve/booth/lat/lng/`,
      { headers: this.headers }
    );
  }

  // logoutClicked() {
  //   return this.http.get(`${this.global.server_url}/main/logout/employee/from/counter/`, { headers: this.headers });
  // }

  getChequeStatusLogForIndividualTransaction(data) {
    return this.http.post(
      `${this.global.server_url}/main/get/cheque/status/logs/for/individual/transaction/`,
      data,
      { headers: this.headers }
    );
  }

  serveTransactionLogForIcustomer(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/last/week/transaction/log/for/icustomers/`,
      data,
      { headers: this.headers }
    );
  }

  prepareIndentForAllClosedRoutes(data) {
    return this.http.post(
      `${this.global.server_url}/main/prepare/indent/for/all/closed/routes/`,
      data,
      { headers: this.headers }
    );
  }

  getOverallPdf(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/indent/pdf/all/closed/routes/`,
      data,
      { headers: this.headers }
    );
  }

  getOverallPdfForOldIndent(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/indent/pdf/all/closed/routes/for/old/indent/`,
      data,
      { headers: this.headers }
    );
  }

  getWardsBasedOnConstituency() {
    return this.http.get(
      `${this.global.server_url}/main/serve/wards/based/on/constituency/`,
      { headers: this.headers }
    );
  }

  serveBusinessListForRouteRearrange(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/business/list/for/route/rearrange/`,
      data,
      { headers: this.headers }
    );
  }

  moveBusinessToTempRoute(data) {
    return this.http.post(
      `${this.global.server_url}/main/move/business/to/temp/route/`,
      data,
      { headers: this.headers }
    );
  }

  moveBusinessToMainRoute(data) {
    return this.http.post(
      `${this.global.server_url}/main/move/business/to/main/route/`,
      data,
      { headers: this.headers }
    );
  }

  serveTempRouteDetails(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/temp/route/details/`,
      data,
      { headers: this.headers }
    );
  }

  serveTempRouteDetailsForOldIndent(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/temp/route/details/for/old/indent/`,
      data,
      { headers: this.headers }
    );
  }

  rearrangeToOriginalRoute(data) {
    return this.http.post(
      `${this.global.server_url}/main/rearrange/business/to/original/route/`,
      data,
      { headers: this.headers }
    );
  }

  deleteSelectedOrder(data) {
    return this.http.post(
      `${this.global.server_url}/main/delete/selected/order/`,
      data,
      { headers: this.headers }
    );
  }

  serveZoneWiseOrderedBusinessData() {
    return this.http.get(
      `${this.global.server_url}/main/serve/zone/wise/ordered/business/data/`,
      { headers: this.headers }
    );
  }

  serveCounterReportForAgent(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/counter/report/for/agent/`,
      data,
      { headers: this.headers }
    );
  }

  serveCounterReportJsonForAgent(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/counter/report/json/for/agent/`,
      data,
      { headers: this.headers }
    );
  }

  serveCounterReportJsonForCustomer(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/counter/report/json/for/customer/`,
      data,
      { headers: this.headers }
    );
  }

  serveCounterList() {
    return this.http.get(`${this.global.server_url}/main/serve/counter/list/`, {
      headers: this.headers,
    });
  }

  checkUserIsAnonymous() {
    return this.http.get(
      `${this.global.server_url}/main/check/user/is/anonymous/`,
      { headers: this.headers }
    );
  }

  getProductDiscountPriceForUpdate(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/product/discount/price/for/update/`,
      data,
      { headers: this.headers }
    );
  }

  serveTotalSaleForSelectedDateCounterWise(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/total/sale/for/selected/date/counter/wise/`,
      data,
      { headers: this.headers }
    );
  }

  serveTotalSaleForSelectedDateCounterWiseAsJson(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/total/sale/for/selected/date/counter/wise/as/json/`,
      data,
      { headers: this.headers }
    );
  }

  serveTotalSalePerMonthInCounter(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/total/sale/per/month/in/counter/`,
      data,
      { headers: this.headers }
    );
  }

  serveTotalSalePerMonthInCounterAsJson(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/total/sale/per/month/in/counter/as/json/`,
      data,
      { headers: this.headers }
    );
  }

  serveRouteWiseSaleAbstract(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/route/wise/sale/abstract/`,
      data,
      { headers: this.headers }
    );
  }

  serveMilkAcknowledgementReport(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/milk/acknowledgement/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveDailySaleForSelectedZone(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/daily/zone/wise/sale/`,
      data,
      { headers: this.headers }
    );
  }

  serveAllZoneReport(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/all/zone/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveUniqueRouteWiseSaleAbstract(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/unique/route/wise/sale/abstract/`,
      data,
      { headers: this.headers }
    );
  }

  deleteSelectedIcustomerSale(data) {
    return this.http.post(
      `${this.global.server_url}/main/delete/selected/icustomer/sale/`,
      data,
      { headers: this.headers }
    );
  }

  deleteSelectedIcustomerSaleForCurrentMonth(data) {
    return this.http.post(
      `${this.global.server_url}/main/delete/selected/icustomer/sale/for/current/month/`,
      data,
      { headers: this.headers }
    );
  }

  getDistrictBasedTaluks() {
    return this.http.get(
      `${this.global.server_url}/main/serve/district/based/taluk/`,
      { headers: this.headers }
    );
  }

  getStateBasedDistrict() {
    return this.http.get(
      `${this.global.server_url}/main/serve/state/based/district/`,
      { headers: this.headers }
    );
  }

  updateBusinessRouteMap(data) {
    return this.http.post(
      `${this.global.server_url}/main/update/business/route/map/`,
      data,
      { headers: this.headers }
    );
  }

  changeVehicle(data) {
    return this.http.post(
      `${this.global.server_url}/main/update/route/vehicle/change/`,
      data,
      { headers: this.headers }
    );
  }

  changeVehicleForRoute(data) {
    return this.http.post(
      `${this.global.server_url}/main/change/route/vehicle/`,
      data,
      { headers: this.headers }
    );
  }

  changeBusinessActiveStatus(data) {
    return this.http.post(
      `${this.global.server_url}/main/change/business/active/status/`,
      data,
      { headers: this.headers }
    );
  }

  serveTransactionHistoryAgent(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/transaction/history/agent/`,
      data,
      { headers: this.headers }
    );
  }

  getEmployeeUserType() {
    return this.http.get(
      `${this.global.server_url}/main/get/employee/user/type/`,
      { headers: this.headers }
    );
  }

  checkAgentCode(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/agent/code/`,
      data,
      { headers: this.headers }
    );
  }

  checkEditOrderPermission(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/edit/order/permission/`,
      data,
      { headers: this.headers }
    );
  }

  serveRouteWiseSaleStatement(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/route/wise/sale/statement/`,
      data,
      { headers: this.headers }
    );
  }

  serveZoneWiseAbstract(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/zone/wise/abstract/`,
      data,
      { headers: this.headers }
    );
  }

  serveBusinessTypeWiseSummary(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/business/type/wise/summary/`,
      data,
      { headers: this.headers }
    );
  }

  serveUnionWiseSummary(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/union/wise/summary/`,
      data,
      { headers: this.headers }
    );
  }

  serveZoneWiseRouteAbstract(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/zone/wise/route/abstract/`,
      data,
      { headers: this.headers }
    );
  }

  getAgentMonthlyCommissionRerpot(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/agent/monthly/commisssion/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveRunListForCommission(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/run/list/for/commission/`,
      data,
      { headers: this.headers }
    );
  }

  getGlobalConfigData() {
    return this.http.get(
      `${this.global.server_url}/main/get/global/config/data/`,
      { headers: this.headers }
    );
  }

  serveAllTypeOfReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/all/type/of/report/`,
      data,
      { headers: this.headers }
    );
  }
  byproductmasteradd(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/save/byproduct/group/`,
      data,
      { headers: this.headers }
    );
  }
  getbyproductunit() {
    return this.http.get(
      `${this.global.server_url}/byproducts/serve/byproduct/unit/`,
      { headers: this.headers }
    );
  }
  serveSimpleComparisionReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/simple/comparision/report/`,
      data,
      { headers: this.headers }
    );
  }

  copm2Areport(data: any) {
    return this.http.post(
      `${this.global.server_url}/report/serve/comp/two/before/twodays/report/`,
      data,
      { headers: this.headers }
    );
  }
  generateFinanceReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/generate/pdf/code/for/cash/finance/report/`,
      data,
      { headers: this.headers }
    );
  }

  generateFinanceReportOnDeliveryDate(data) {
    return this.http.post(
      `${this.global.server_url}/report/generate/pdf/code/for/cash/finance/report/on/delivery/date/`,
      data,
      { headers: this.headers }
    );
  }

  generateInstitutionBillForMilk(data) {
    return this.http.post(
      `${this.global.server_url}/report/generate/institution/bill/for/milk/`,
      data,
      { headers: this.headers }
    );
  }

  generateInstitutionBillwithGST(data) {
    return this.http.post(
      `${this.global.server_url}/report/generate_institution_bill_with_gst/`,
      data,
      { headers: this.headers }
    );
  }

  generateInstitutionBillForCurd(data) {
    return this.http.post(
      `${this.global.server_url}/report/generate/institution/bill/for/curd/`,
      data,
      { headers: this.headers }
    );
  }

  generateTotalMilkSaleReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/generate/pdf/code/for/total/milk/sale/`,
      data,
      { headers: this.headers }
    );
  }

  serveOnlinePaymentLog(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/payment/request/and/responce/details/`,
      data,
      { headers: this.headers }
    );
  }

  generateTotalCurdSaleReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/generate/pdf/code/for/total/curd/sale/`,
      data,
      { headers: this.headers }
    );
  }

  serveInstituteBillAsDbf(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/institution/bill/as/dbf/`,
      data,
      { headers: this.headers }
    );
  }

  serveLastMonthCounterOrder() {
    return this.http.get(
      `${this.global.server_url}/main/serve/last/month/order/count/for/counter/`,
      { headers: this.headers }
    );
  }

  channgeRouteExpiryTime(data) {
    return this.http.post(
      `${this.global.server_url}/main/change/route/expiry/time/`,
      data,
      { headers: this.headers }
    );
  }

  channgeOverallRouteExpiryTime(data) {
    return this.http.post(
      `${this.global.server_url}/main/change/overall/route/expiry/time/`,
      data,
      { headers: this.headers }
    );
  }

  serveTrayCountReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/tray/count/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveLeakageAllowanceReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/leakage/allowance/details/`,
      data,
      { headers: this.headers }
    );
  }

  serveAdvanceReportInExcel(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/advance/report/in/excel/`,
      data,
      { headers: this.headers }
    );
  }

  serveAdvanceReportInExcelForRoute(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/advance/report/in/excel/for/route/`,
      data,
      { headers: this.headers }
    );
  }

  runBoothCommission(data) {
    return this.http.post(
      `${this.global.server_url}/report/run/booth/commission/for/seleted/date/range/`,
      data,
      { headers: this.headers }
    );
  }

  customerCardPreview(data) {
    return this.http.post(
      `${this.global.server_url}/main/customer/card/preview/`,
      data,
      { headers: this.headers }
    );
  }

  serveDataForGeneralReport() {
    return this.http.get(
      `${this.global.server_url}/report/serve/zone/booth/route/data/gor/general/report/`,
      { headers: this.headers }
    );
  }

  serveSaleGroupDeleteLog() {
    return this.http.get(
      `${this.global.server_url}/main/serve/sale/group/delele/log/`,
      { headers: this.headers }
    );
  }

  serveRouteTimeChangeLog() {
    return this.http.get(
      `${this.global.server_url}/main/serve/route/time/change/log/`,
      { headers: this.headers }
    );
  }

  serveRouteBusinessChangeLog() {
    return this.http.get(
      `${this.global.server_url}/main/serve/route/business/change/log/`,
      { headers: this.headers }
    );
  }

  serveICustomerBusinessChangeLog() {
    return this.http.get(
      `${this.global.server_url}/main/serve/icustomer/business/change/log/`,
      { headers: this.headers }
    );
  }

  serveICustomerBusinessChangeLogExcelFilter() {
    return this.http.get(
      `${this.global.server_url}/main/serve/icustomer/business/change/log/excel/filter/`,
      { headers: this.headers }
    );
  }

  serveICustomerBusinessChangeLogExcelFilterWithParams(data: { employee_type: string, month: string }) {
    const params = {
      employee_type: data.employee_type,
      month: data.month
    };

    return this.http.get(
      `${this.global.server_url}/main/serve/icustomer/business/change/log/excel/filter/`,
      {
        headers: this.headers,
        params: params
      }
    );
  }

  getMonthlyInstituteAbstract(data) {
    return this.http.post(
      `${this.global.server_url}/report/generate/monthly/institution/bill/abstract/`,
      data,
      { headers: this.headers }
    );
  }

  makeEnquiryFromPortal(data) {
    return this.http.post(
      `${this.global.server_url}/main/create/encryption/text/and/make/enquiry/`,
      data,
      { headers: this.headers }
    );
  }

  serveEnquiryRequestLog(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/enquiry/request/log/`,
      data,
      { headers: this.headers }
    );
  }

  getEmployeeRoleMenu() {
    this.http
      .get(`${this.global.server_url}/main/serve/employee/role/menu/`, {
        headers: this.headers,
      })
      .toPromise()
      .then((data) => {
        console.log(data);
        localStorage.setItem("headers", JSON.stringify(data["header"]));
        localStorage.setItem("pages", JSON.stringify(data["page"]));
        this.authenticationService.menu_header.emit(data);
      });
  }

  registerBoothWithNominee(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/booth/with/nominee/`,
      data,
      { headers: this.headers }
    );
  }

  getBoothDetailsForUpdate(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/booth/details/for/update/`,
      data,
      { headers: this.headers }
    );
  }

  saveIndividualFieldInAgentBooth(data) {
    return this.http.post(
      `${this.global.server_url}/main/save/individual/field/in/agent/booth/`,
      data,
      { headers: this.headers }
    );
  }

  serveAutoEnquiryLog(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/auto/enquiry/log/`,
      data,
      { headers: this.headers }
    );
  }

  serveBulkCustomerCardData(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/bulk/customer/card/data/`,
      data,
      { headers: this.headers }
    );
  }

  serveBoothWiseCustomerOrder(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/customer/order/statement/selected/booth/`,
      data,
      { headers: this.headers }
    );
  }

  serveBulkBoothWiseCustomerOrder(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/customer/order/statement/bulk/booth/`,
      data,
      { headers: this.headers }
    );
  }

  serveCompReportFive(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/comparision/five/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveMonthlyBillAbstract(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/monthly/bill/abstract/`,
      data,
      { headers: this.headers }
    );
  }

  serveAccountSectionPaymentReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/account/section/online/payment/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveReportThree(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/monthly/dairy/summary/as/report/three/`,
      data,
      { headers: this.headers }
    );
  }

  serveIcustomerPersonalDeails(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/icustomer/details/for/edit/`,
      data,
      { headers: this.headers }
    );
  }

  updateIcustomerPersonalDeails(data) {
    return this.http.post(
      `${this.global.server_url}/main/update/icustomer/details/`,
      data,
      { headers: this.headers }
    );
  }

  serveYears() {
    return this.http.get(
      `${this.global.server_url}/main/serve/year/list/for/comparision/five/`,
      { headers: this.headers }
    );
  }

  confirmMobileVerfication(data) {
    return this.http.post(
      `${this.global.server_url}/main/confirm/mobile/verification/`,
      data,
      { headers: this.headers }
    );
  }

  serveTransactionLog(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/transaction/log/`,
      data,
      { headers: this.headers }
    );
  }

  serveMilkSupplyFroCardCustomer(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/monthly/supplyed/milk/for/card/customer/`,
      data,
      { headers: this.headers }
    );
  }

  serveMnthlyMilkAbstract(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/monthly/milk/abstract/`,
      data,
      { headers: this.headers }
    );
  }

  serveIncentiveReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/incentive/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveOnlinePaymentTransationReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/online/payment/transation/report/`,
      data,
      { headers: this.headers }
    );
  }
  serveAgentTotalTransaction(data) {
    return this.http.post(
      `${this.global.server_url}/report/agent/total/transaction/report/`,
      data,
      { headers: this.headers }
    );
  }
  serveBusinessTypes() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/types/`,
      { headers: this.headers }
    );
  }

  serveSuperSaleGroup(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/super/sale/group/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveSuperSaleGroupForCounter(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/counter/amount/in/super/sale/group/`,
      data,
      { headers: this.headers }
    );
  }

  serveSuperSaleGroupForOnline(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/online/amount/in/super/sale/group/`,
      data,
      { headers: this.headers }
    );
  }

  serveSuperSaleGroupForWallet(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/wallet/amount/in/super/sale/group/`,
      data,
      { headers: this.headers }
    );
  }

  serveDayWiseTrayTotalCount(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/day/wise/tray/total/count/`,
      data,
      { headers: this.headers }
    );
  }

  serveSuperSaleGroupForProduct(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/product/wise/super/sale/group/`,
      data,
      { headers: this.headers }
    );
  }

  serveMonthlyCounterSale(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/monthly/counter/wise/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveCounterEmployeeSaleForDate(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/counter/employe/sale/for/date/`,
      data,
      { headers: this.headers }
    );
  }

  checkIndentStatus(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/indent/staus/`,
      data,
      { headers: this.headers }
    );
  }

  serveBoothWiseAgentDetails(data) {
    return this.http.post(
      `${this.global.server_url}/report/booth/wise/agent/details/`,
      data,
      { headers: this.headers }
    );
  }

  serveCounterReportJsonForAgentDelivery(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/counter/report/json/for/agent/delivery/`,
      data,
      { headers: this.headers }
    );
  }

  serveCounterReportForAgentDelivery(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/counter/report/for/agent/delivery/`,
      data,
      { headers: this.headers }
    );
  }

  serveCustomerDetails(data) {
    return this.http.post(
      `${this.global.server_url}/report/customer/details/`,
      data,
      { headers: this.headers }
    );
  }

  serveCreateDailyRunLog(data) {
    return this.http.post(
      `${this.global.server_url}/report/create/daily/run/log/`,
      data,
      { headers: this.headers }
    );
  }

  serveDataForDailyDataUploadScript(data) {
    return this.http.post(
      `${this.global.server_url}/report/daily/data/upload/script/call/`,
      data,
      { headers: this.headers }
    );
  }

  serveDailyScriptCompletedStatus(data) {
    return this.http.post(
      `${this.global.server_url}/report/daily/script/complete/status/`,
      data,
      { headers: this.headers }
    );
  }

  checkNextMonthOrder(data) {
    return this.http.post(
      `${this.global.server_url}/main/check/next/month/order/is/available/for/customer/portal/`,
      data,
      { headers: this.headers }
    );
  }

  getEmployeeLastOrderList(data) {
    return this.http.post(
      `${this.global.server_url}/main/get/employee/last/order/details/`,
      data,
      { headers: this.headers }
    );
  }

  getEmployeeProducts() {
    return this.http.get(
      `${this.global.server_url}/main/serve/product/list/for/employe/`,
      { headers: this.headers }
    );
  }

  placeEmployeeOrder(data) {
    return this.http.post(
      `${this.global.server_url}/main/place/employee/order/`,
      data,
      { headers: this.headers }
    );
  }

  placeEmployeeOrderForCurentMonth(data) {
    return this.http.post(
      `${this.global.server_url}/main/place/employee/order/current/month/`,
      data,
      { headers: this.headers }
    );
  }

  getEmployeeList() {
    return this.http.get(`${this.global.server_url}/main/serve/employe/list/`, {
      headers: this.headers,
    });
  }

  placeNewOrderForEmployee(data) {
    return this.http.post(
      `${this.global.server_url}/main/new/employee/order/`,
      data,
      { headers: this.headers }
    );
  }

  placeNewEmployeeOrderForCurrentMonth(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/employee/for/new/order/for/currrent/month/`,
      data,
      { headers: this.headers }
    );
  }

  excelForSociety(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/excel/for/society/bill/`,
      data,
      { headers: this.headers }
    );
  }

  serveInputStock() {
    return this.http.get(
      `${this.global.server_url}/byproducts/serve/by/product/stock/record/`,
      { headers: this.headers }
    );
  }

  serveGoodsGRNNumber() {
    return this.http.get(
      `${this.global.server_url}/byproducts/serve/new/grn/number/`,
      { headers: this.headers }
    );
  }

  updateGRNNumber() {
    return this.http.get(
      `${this.global.server_url}/byproducts/update/grn/back/to/original/digit/`,
      { headers: this.headers }
    );
  }

  serveByProductList() {
    return this.http.get(
      `${this.global.server_url}/byproducts/serve/by/product/list/`,
      { headers: this.headers }
    );
  }

  serveBusinessTypeWisePriceForByProduct(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/business/type/wise/discount/price/dict/for/by/product/`,
      data,
      { headers: this.headers }
    );
  }

  serveBusinessTypeForByProductPrice() {
    return this.http.get(
      `${this.global.server_url}/byproducts/serve/business/type/list/for/by/product/price/`,
      { headers: this.headers }
    );
  }

  createInputStockRecord(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/create/input/stock/record/`,
      data,
      { headers: this.headers }
    );
  }

  serveGoodsRecordForProduct(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/goods/record/for/selected/product/`,
      data,
      { headers: this.headers }
    );
  }
  removeaddproductgrn(data: any) {
    return this.http.post(
      `${this.global.server_url}/byproducts/save/delete_grn_record/`,
      data,
      { headers: this.headers }
    );
  }

  serveRoutesForLeakage() {
    return this.http.get(
      `${this.global.server_url}/report/serve/route/for/leakage/allowance/details/`,
      { headers: this.headers }
    );
  }

  serveByProductOrderForGatepass() {
    return this.http.get(
      `${this.global.server_url}/byproducts/serve/by/product/order/list/for/gatepass/`,
      { headers: this.headers }
    );
  }

  prepareGatepassForByProduct(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/prepare/gate/pass/for/by/product/`,
      data,
      { headers: this.headers }
    );
  }

  prepareGatepassForByProductEmployee(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/prepare/gate/pass/for/by/product/employee/`,
      data,
      { headers: this.headers }
    );
  }

  downloadByProductGatePass(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/download/gate/pass/for/by/product/`,
      data,
      { headers: this.headers }
    );
  }

  downloadByProductGatePassForEmployee(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/download/gate/pass/for/by/product/employee/`,
      data,
      { headers: this.headers }
    );
  }

  registerOrUpdateByProduct(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/register/or/update/by/product/`,
      data,
      { headers: this.headers }
    );
  }

  saveOrUpdateBusinessTypeWiseProductDiscountPriceForByProduct(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/save/or/update/business/type/wise/discount/price/for/by/product/`,
      data,
      { headers: this.headers }
    );
  }

  removeBusinessTypeWiseProductPriceForByProduct(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/remove/business/type/wise/product/for/by/product/`,
      data,
      { headers: this.headers }
    );
  }

  serveByProductOrderForSelectedBusiness(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/by/product/order/list/for/selected/business/`,
      data,
      { headers: this.headers }
    );
  }

  serveByProductOrderForEmployee(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/by/product/order/list/for/employee/`,
      data,
      { headers: this.headers }
    );
  }

  serveBillingPreview(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/billing/preview/for/employee/order/`,
      data,
      { headers: this.headers }
    );
  }

  serveCounterOrdersForByProduct() {
    return this.http.get(
      `${this.global.server_url}/byproducts/serve/counter/orders/for/by/product/`,
      { headers: this.headers }
    );
  }

  serveBusinessDetailsForByProduct(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/business/details/for/by/product/order/`,
      data,
      { headers: this.headers }
    );
  }

  serveByProductListForOrder(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/by/product/list/for/order/`,
      data,
      { headers: this.headers }
    );
  }

  serveByProductAvailabiltyAndPriceList(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/by/product/availablity/and/price/list/`,
      data,
      { headers: this.headers }
    );
  }

  serveWalletBalanceAndOrderCategory(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/wallet/balance/and/order/category/`,
      data,
      { headers: this.headers }
    );
  }

  registerOrderForByProductAgent(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/register/order/for/by/product/agent/`,
      data,
      { headers: this.headers }
    );
  }

  registerOrderForByProductEmployee(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/register/order/for/by/product/employee/`,
      data,
      { headers: this.headers }
    );
  }

  counterWiseSaleSummaryForByproducts(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/counter/wise/sale/summary/for/byproducts/`,
      data,
      { headers: this.headers }
    );
  }

  serveCounterSaleByProductsReport(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/counter/sale/by/products/report/`,
      data,
      { headers: this.headers }
    );
  }

  returnGRNAndOrderToMainEmployeeOrder(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/return/grn/and/order/to/main/employee/order/`,
      data,
      { headers: this.headers }
    );
  }

  serveGoodsProductRecordForEmployeeOrder(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/goods/product/record/for/employee/order/`,
      data,
      { headers: this.headers }
    );
  }

  serveByProductCounters() {
    return this.http.get(
      `${this.global.server_url}/byproducts/serve/by/product/counters/`,
      { headers: this.headers }
    );
  }

  serveExcelOnlinePaymentLog(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/payment/request/and/responce/details/in/excel/`,
      data,
      { headers: this.headers }
    );
  }

  serveExcelForEmployeeOrder(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/excel/for/employee/and/exemployee/product/and/quandity/details/`,
      data,
      { headers: this.headers }
    );
  }

  bankTransactionExcelUpload(data) {
    return this.http.post(
      `${this.global.server_url}/transaction/upload/bank/transaction/excel/`,
      data,
      { headers: this.headers }
    );
  }

  deletebankTransactionExcelUpload(bank_transaction_master_id: number) {
    return this.http.delete(
      `${this.global.server_url}/transaction/delete/bank/transaction/master/?bank_transaction_master_id=${bank_transaction_master_id}`,
      { headers: this.headers }
    );
  }

  serveCombainOnlineReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/combain/online/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveCityWiseSaleExcelReport(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/excel/for/city/wise/sale/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveProductCatagory() {
    return this.http.get(
      `${this.global.server_url}/report/serve/product/type/list/from/product/finance/code/map/`,
      { headers: this.headers }
    );
  }

  bankTransactionUploadDetails() {
    return this.http.get(
      `${this.global.server_url}/transaction/serve/bank/transaction/uploaded/detalils/`,
      { headers: this.headers }
    );
  }

  bankTransactionExcel1(data) {
    return this.http.post(
      `${this.global.server_url}/transaction/serve/bank/transaction/report1/`,
      data,
      { headers: this.headers }
    );
  }

  bankTransactionExcel2(data) {
    return this.http.post(
      `${this.global.server_url}/transaction/serve/bank/transaction/report2/`,
      data,
      { headers: this.headers }
    );
  }

  bankTransactionExcel2a(data) {
    return this.http.post(
      `${this.global.server_url}/transaction/serve/bank/transaction/report2a/`,
      data,
      { headers: this.headers }
    );
  }

  bankTransactionExcel3(data) {
    return this.http.post(
      `${this.global.server_url}/transaction/serve/bank/transaction/report3/`,
      data,
      { headers: this.headers }
    );
  }

  bankTransactionExcel4(data) {
    return this.http.post(
      `${this.global.server_url}/transaction/serve/bank/transaction/report4/`,
      data,
      { headers: this.headers }
    );
  }

  customerDeleteLog() {
    return this.http.get(
      `${this.global.server_url}/main/serve/customer/order/delete/log/`,
      { headers: this.headers }
    );
  }

  customerDeleteLogExcelFilter() {
    return this.http.get(
      `${this.global.server_url}/main/serve/customer/order/delete/log/excel/filter/`,
      { headers: this.headers }
    );
  }

  customerDeleteLogExcelFilterWithParams(data: { employee_type: string, month: string }) {
    const params = {
      employee_type: data.employee_type,
      month: data.month
    };

    return this.http.get(
      `${this.global.server_url}/main/serve/customer/order/delete/log/excel/filter/`,
      {
        headers: this.headers,
        params: params
      }
    );
  }

  serveCustomerTypes() {
    return this.http.get(
      `${this.global.server_url}/transaction/serve/customer/types/`,
      { headers: this.headers }
    );
  }

  serveDateRangeWiseSaleAndTrasactionData(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/date/range/wise/sale/and/transaction/`,
      data,
      { headers: this.headers }
    );
  }

  serveBusinessTypeWiseBooth() {
    return this.http.get(
      `${this.global.server_url}/report/serve/business/type/wise/business/for/bill/`,
      { headers: this.headers }
    );
  }

  validateAndServeDataForMismatch(data) {
    return this.http.post(
      `${this.global.server_url}/report/validate/and/serve/data/for/mismatch/`,
      data,
      { headers: this.headers }
    );
  }

  serveDailyCashAndCreditStatement(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/daily/cash/and/credit/statement/`,
      data,
      { headers: this.headers }
    );
  }

  servePurchaseCompany() {
    return this.http.get(
      `${this.global.server_url}/byproducts/serve/purchase/company/`,
      { headers: this.headers }
    );
  }

  servePaymentMethod() {
    return this.http.get(
      `${this.global.server_url}/byproducts/serve/sale/group/payment/method/`,
      { headers: this.headers }
    );
  }

  registerPurchaseCompany(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/register/purchase/company/`,
      data,
      { headers: this.headers }
    );
  }

  serveDailySaleForByProduct(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/daily/sale/quantity/business/wise/`,
      data,
      { headers: this.headers }
    );
  }

  serveDailySaleQuantityProductWise(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/daily/sale/quantity/product/wise/`,
      data,
      { headers: this.headers }
    );
  }

  updateDailySaleForByProduct(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/update/daily/sale/quantity/business/wise/`,
      data,
      { headers: this.headers }
    );
  }

  updateEditDailySaleForByProduct(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/update/edit/daily/sale/quantity/business/wise/`,
      data,
      { headers: this.headers }
    );
  }

  monthlySaleRegisterReport(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/monthly/sale/regisred/dealers/`,
      data,
      { headers: this.headers }
    );
  }

  monthlySaleNonRegisterReport(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/monthly/sale/non/regisred/dealers/`,
      data,
      { headers: this.headers }
    );
  }

  monthlySaleOverAllReport(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/monthly/sale/regisred/unregisred/dealers/`,
      data,
      { headers: this.headers }
    );
  }

  monthlyProductSaleAbstractReport(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/monthly/product/sales/abstract/report/`,
      data,
      { headers: this.headers }
    );
  }

  downloadCashReceipt(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/download/cash/receipt/`,
      data,
      { headers: this.headers }
    );
  }

  serveVehicleGatepassAndOrder(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/vehicle/gate/pass/and/order/`,
      data,
      { headers: this.headers }
    );
  }

  prepareVehicleGatePass(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/prepare/vehicle/gate/pass/`,
      data,
      { headers: this.headers }
    );
  }

  // serveDailyStockReport(data) {
  //   return this.http.post(`${this.global.server_url}/byproducts/serve/daily/stock/report/in/excel/`, data,  { headers: this.headers });
  // }byproduct/daily/stock/report/new

  serveDailyStockReport(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/daily/stock/report/in/pdf/`,
      data,
      { headers: this.headers }
    );
  }
  serveDailyStockReportNew(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/save/daily/stock/report/`,
      data,
      { headers: this.headers }
    );
  }
  closeSale(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/close/daily/sale/`,
      data,
      { headers: this.headers }
    );
  }

  serveDailyForSelectedDate(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/daily/sale/for/selected/date/`,
      data,
      { headers: this.headers }
    );
  }

  dailySaleUpload(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/daily/sale/upload/`,
      data,
      { headers: this.headers }
    );
  }

  openSale() {
    return this.http.get(
      `${this.global.server_url}/byproducts/open/daily/sale/`,
      { headers: this.headers }
    );
  }

  serveDailyCloseStatus() {
    return this.http.get(
      `${this.global.server_url}/byproducts/serve/daily/close/status/`,
      { headers: this.headers }
    );
  }

  deleteOverallSale() {
    return this.http.get(
      `${this.global.server_url}/byproducts/delete/overall/sale/and/grn/`,
      { headers: this.headers }
    );
  }

  deleteSelectedSale(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/delete/selected/by/product/order/`,
      data,
      { headers: this.headers }
    );
  }
  salesTaxAbstract(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/sales/tax/abstract/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveGovtJson(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve_json_for_govt_upload/`,
      data,
      { headers: this.headers }
    );
  }

  serveGovtGstBill(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve_govt_gst_bill/`,
      data,
      { headers: this.headers }
    );
  }

  serveFermentedGovtGstBill(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve_govt_jst_bill_summary/`,
      data,
      { headers: this.headers }
    );
  }

  serveFermentedGovtJson(data) {
    return this.http.post(
      `${this.global.server_url}/report/serve/json/fermented/products/govt/upload/`,
      data,
      { headers: this.headers }
    );
  }

  serveByProductAnalystics(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/byproduct/analytic/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveDailyCashAndCreditStatementExcel(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/daily/cash/and/credit/statement/excel/`,
      data,
      { headers: this.headers }
    );
  }

  serveZoneWiseReport(data) {
    return this.http.post(
      `${this.global.server_url}/byproducts/serve/zone/wise/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveFreeMilkReport(data) {
    return this.http.post(
      `${this.global.server_url}/main/serve/free/milk/report/`,
      data,
      { headers: this.headers }
    );
  }

  serveRelianceBillNumWiseReport(data) {
    return this.http.post(
      `${this.global.server_url}/main/reliance/bill/number/wise/report/`,
      data,
      { headers: this.headers }
    );
  }
  getBusinessType() {
    return this.http.get(
      `${this.global.server_url}/main/serve/business/type/`,
      { headers: this.headers }
    );
  }
  servebusinessname(data) {
    return this.http.post(
      `${this.global.server_url}/main/business/type/name/dict/type/post/`,
      data,
      { headers: this.headers }
    );
  }
  savebusinesswisecreditamount(data: any) {
    return this.http.post(
      `${this.global.server_url}/main/payment/record/save/`,
      data,
      { headers: this.headers }
    );
  }

  servebusinesscrdeidliitamount(data: any) {
    return this.http.post(
      `${this.global.server_url}/main/serve/payment/record/`,
      data,
      { headers: this.headers }
    );
  }

  getdashboarddata(selectedData: { selected_option: string }) {
    const params = { selected_option: selectedData.selected_option }; // Construct the query parameter object

    return this.http.get(`${this.global.server_url}/main/overall/dashboard/`, {
      headers: this.headers,
      params: params, // Pass the query parameters here
    });
  }
}
